<template>
  <div
    class="file-uploader"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    :class="{ 'drag-over': isDragOver, uploading: isUploading }"
  >
    <input type="file" ref="fileInput" class="file-input" @change="onFileSelected" :disabled="isUploading" />
    <div class="file-uploader-content" @click="!isUploading && $refs.fileInput.click()">
      <span class="py-2">
        <v-icon start v-if="!isUploading">mdi-upload</v-icon>
        <v-progress-circular v-if="isUploading" indeterminate size="20" class="mr-2"></v-progress-circular>
        <span>{{ isUploading ? "Uploading..." : label || "Click to upload" }}</span>
      </span>
    </div>
    <div v-if="uploadedFileName && !isUploading" class="uploaded-file-name">
      {{ uploadedFileName }}
    </div>
  </div>
</template>
<script>
import httpService from "@/services/httpService";

export default {
  props: {
    success: Function,
    onFinished: Function,
    onBeforeSending: Function,
    url: String,
    label: String,
    fileUploadData: Object,
  },

  data() {
    return {
      isDragOver: false,
      uploadedFileName: null,
      maxFilesize: 5, // MB
      isUploading: false,
    };
  },

  methods: {
    onDragOver() {
      this.isDragOver = true;
    },
    onDragLeave() {
      this.isDragOver = false;
    },
    onDrop(event) {
      this.isDragOver = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.processFile(files[0]);
      }
    },
    onFileSelected(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.processFile(files[0]);
      }
    },
    processFile(file) {
      if (file.name.length > 175) {
        this.$root.$snackbar.error("File name is too long. Please use a shorter file name.");
        if (this.onFinished) this.onFinished();
        return;
      }

      const maxBytes = this.maxFilesize * 1024 * 1024;
      if (file.size > maxBytes) {
        this.$root.$snackbar.error(`File size exceeds ${this.maxFilesize}MB limit.`);
        if (this.onFinished) this.onFinished();
        return;
      }

      this.uploadFile(file);
    },
    async uploadFile(file) {
      if (this.onBeforeSending) this.onBeforeSending();

      this.isUploading = true;
      const uploadUrl = this.url || "/companyImage/upload";

      try {
        const data = await httpService.postFile(uploadUrl, file, this.fileUploadData ? { fileUploadData: this.fileUploadData } : null);
        this.uploadedFileName = file.name;

        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }

        this.$root.$snackbar.message("File uploaded successfully!");

        if (this.success) {
          this.success(file, data);
        }
      } catch (error) {
        console.error("Upload error:", error);
        this.$root.$snackbar.error(`Upload failed: ${error.message}`);
        if (this.onFinished) this.onFinished();
      } finally {
        this.isUploading = false;
      }
    },
  },
};
</script>
<style>
.file-uploader {
  position: relative;
  cursor: pointer;
  border: 1px dashed rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 4px;
  padding: 8px 16px;
  text-align: left;
  transition: border-color 0.2s;
}
.file-uploader:hover,
.file-uploader.drag-over {
  border-color: rgb(var(--v-theme-primary));
}
.file-uploader.uploading {
  cursor: not-allowed;
  opacity: 0.7;
  border-color: rgb(var(--v-theme-primary));
}
.file-uploader.uploading .file-uploader-content {
  cursor: not-allowed;
}
.file-uploader .file-input {
  display: none;
}
.file-uploader-content {
  cursor: pointer;
}
.uploaded-file-name {
  font-size: 12px;
  color: rgba(var(--v-theme-on-surface), 0.6);
  margin-top: 4px;
}
</style>
